import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { NotesView } from "../vehicleDetails/overview/notes/NotesView"

export interface GetNotesViewPathParams {
	inventoryId: string
}

export const getNotesViewRoute: ApiRoute<GetNotesViewPathParams, NoQueryParams, NoBody, NotesView> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/notes`,
	method: "get",
	path: "/vehicles/:inventoryId/notes",
}
